import React from 'react';
import SiteListView from '../../SiteListView';

export default ({ sitesReady, realm }) => (
  <SiteListView
    sitesReady={sitesReady}
    realm={realm}
  />
);
